/* 🤖 this file was generated by script */
export const wiconSun = {
  name: 'sun',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 2v2m0 16v2M4 12H2m4.31-5.69L4.9 4.9m12.79 1.41L19.1 4.9M6.31 17.69L4.9 19.1m12.79-1.41l1.41 1.41M22 12h-2m-3 0a5 5 0 11-10 0 5 5 0 0110 0z"/></svg>`,
};
